// extracted by mini-css-extract-plugin
export default {"newPost_textarea":"AutoGrowingTextArea_newPost_textarea__KjnD0"};